
<template>
    <div class="pb-4">
        <div class="fixed-top setup-navbar">
            <img src="../../assets/images/setup/logo.svg" alt="Rush Logo">
        </div>
        <h1 class="text-center">Upgrade Plan</h1>
        <p class="text-center description">Lorem ipsum dolor sit amet, co nsectetur adipiscing elit. Lorem ipsum dolor sit amet, consect etur.</p>
        <div class="setup-form-wrapper container p-0">
            <div class="progressbar-wrapper" v-show="!subIsActive('/upgrade/success')">
                <ul class="progressbar list-unstyled mx-auto">
                    <li v-bind:class="{ 'done': !subIsActive('/upgrade/start'), 'active': subIsActive('/upgrade/start') }">Plans</li>
                    <li v-bind:class="{ 'done': !subIsActive('/upgrade/step-2') && !subIsActive('/upgrade/start'), 'active': subIsActive('/upgrade/step-2') }">Add On’s</li>
                    <li v-bind:class="{ 'active': subIsActive('/upgrade/step-3') }">Enter Payment</li>
                </ul>
            </div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'setup',
    data() {
        return {

        }
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        }
    }
};
</script>
<style lang="scss">
</style>